import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ensureReady } from "../i18n/i18nLoader";

export const useTranslationLoader = () => {
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const loadTranslations = useCallback(
    async (language?: string) => {
      const targetLanguage = language ?? i18n.language;
      setIsLoading(true);
      const TRANSLATION_LOAD_MS = 12_000;
      try {
        await Promise.race([
          ensureReady({ lng: targetLanguage, nsList: ["common"] }),
          new Promise<never>((_, reject) =>
            setTimeout(
              () => reject(new Error("Translation load timed out")),
              TRANSLATION_LOAD_MS
            )
          ),
        ]);
        setIsLoaded(true);
      } catch (error) {
        console.error("Failed to load translations:", error);
        setIsLoaded(true);
      } finally {
        setIsLoading(false);
      }
    },
    [i18n.language]
  );

  useEffect(() => {
    loadTranslations();
  }, [loadTranslations]);

  useEffect(() => {
    if (isLoaded) {
      loadTranslations();
    }
  }, [i18n.language, isLoaded, loadTranslations]);

  return {
    isLoading,
    isLoaded,
    loadTranslations,
    currentLanguage: i18n.language,
  };
};
